module.exports = __webpack_public_path__ + "img/banner.c5ff9245.png";